/**
 * Resolves once `p` settles, resolved or rejected, or after `ms`, whichever
 * comes first; never rejects. The call's join waits on the last leave this
 * way: a Rejoin right after Leave otherwise had its join written before the
 * leave, and the other side read "left" until the next check-in.
 * Pure, so tested.
 */
export function settledWithin(p: Promise<unknown>, ms: number): Promise<void> {
  return new Promise<void>((resolve) => {
    const t = setTimeout(resolve, ms);
    p.then(() => { clearTimeout(t); resolve(); }, () => { clearTimeout(t); resolve(); });
  });
}
